module.exports = __webpack_public_path__ + "media/images/j-09438e09.png";